import config from 'services/config'
import LocalUserService from 'services/localUserService'

const userService = new LocalUserService()

async function sendDownloadLink(phone) {
  const response = await fetch(`${config.coreApiUrl}/app/sendDownloadLink`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'sp-auth': userService.getCurrentUserInfo()?.sessionId
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify({ phone })
  })

  return response.json()
}

const coreApi = {
  sendDownloadLink
}

export default coreApi
